let id = 0;

export function getUniqueId(): string {
    id += 1;

    return id.toString();
}
